/*
Copyright 2024 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-NevaiMeet-Commercial
Please see LICENSE in the repository root for full details.
*/

export type CallType = "meet" | "coffee" | "video";

// Carries the chosen call type from the home "create call" screen into the
// call view that is mounted right after navigation. Reset to "meet" once read
// so a later direct room link defaults to a normal meeting.
let pendingCallType: CallType = "meet";

export function setPendingCallType(type: CallType): void {
  pendingCallType = type;
}

export function consumePendingCallType(): CallType {
  const type = pendingCallType;
  pendingCallType = "meet";
  return type;
}
